import Vue from 'vue';
// eslint-disable-next-line
export const domainsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/domains/domainsEventBus.js